import React, { useState } from "react";
import ComponentList from "./components/ComponentList";
import { PlusCircleOutlined } from "@ant-design/icons";
import { Button } from "antd";
import CreateAgentModal from "./components/CreateAgentModal";
import AIConfigModal from "./components/AIConfigModal";
import DeviceModal from "./components/DeviceModal";
import ChatRecordModal from "./components/ChatRecordModal";
import { injectIntl, FormattedMessage } from "react-intl";
import styles from "./index.css";

const AgentManage = (props) => {
    const { intl } = props;
    const [modalOpen, setModalOpen] = useState(false);
    const [roleModalShow, setRoleModalShow] = useState(false);
    const [deviceModalShow, setDeviceModalShow] = useState(false);
    const [chatRecordModalShow, setChatRecordModalShow] = useState(false);
    const [agentInfo, setAgentInfo] = useState({
        id: "",
        name: "",
    });
    const [listKey, setListKey] = useState(0);

    const handleCreateAgent = (agentName) => {
        setListKey((prev) => prev + 1);
        setModalOpen(false);
    };

    return (
        <div className={styles.container}>
            <div flex="cross:center main:justify" className={styles.addAgent}>
                <div>
                    <div
                        style={{
                            color: "#666",
                            fontSize: "18px",
                            fontWeight: "bold",
                            marginBottom: 18,
                        }}
                    >
                        <FormattedMessage
                            id="gui.agentManage.title"
                            defaultMessage="Agent Management"
                        />
                    </div>
                    <div style={{ color: "#999", fontSize: 14 }}>
                        <div
                            style={{
                                fontSize: 16,
                                fontWeight: "bold",
                                marginBottom: 12,
                            }}
                        >
                            <FormattedMessage
                                id="gui.agentManage.descriptionTitle"
                                defaultMessage="Description:"
                            />
                        </div>
                        <div style={{ marginBottom: 12 }}>
                            <FormattedMessage
                                id="gui.agentManage.description1"
                                defaultMessage="1. Users can choose to use the default agent to bind devices or add new agents to bind devices"
                            />
                        </div>
                        <div>
                            <FormattedMessage
                                id="gui.agentManage.description2"
                                defaultMessage="2. Users can create new agents and edit agent information and device bindings"
                            />
                        </div>
                    </div>
                </div>
                <Button
                    style={{
                        height: 50,
                        backgroundColor: "#3f79ff",
                    }}
                    type="primary"
                    onClick={() => setModalOpen(true)}
                >
                    <span style={{ marginRight: 6 }}>
                        <FormattedMessage
                            id="gui.agentManage.addAgent"
                            defaultMessage="Add Agent"
                        />
                    </span>
                    <PlusCircleOutlined />
                </Button>
            </div>
            <div className={styles.agentList}>
                <ComponentList
                    key={listKey}
                    setAgentRole={(agent) => {
                        setAgentInfo(agent);
                        setRoleModalShow(true);
                    }}
                    setDeivice={(agent) => {
                        setAgentInfo(agent);
                        setDeviceModalShow(true);
                    }}
                    setChatRecordModalShow={(agent) => {
                        setAgentInfo(agent);
                        setChatRecordModalShow(true);
                    }}
                />
            </div>
            <CreateAgentModal
                open={modalOpen}
                onOk={handleCreateAgent}
                onCancel={() => setModalOpen(false)}
            />

            <AIConfigModal
                agentId={agentInfo?.id}
                visible={roleModalShow}
                onClose={() => setRoleModalShow(false)}
                onSave={() => {
                    setListKey((pre) => pre + 1);
                    setRoleModalShow(false);
                }}
                initialData={{}}
            />

            {deviceModalShow && (
                <DeviceModal
                    agentInfo={agentInfo}
                    visible={deviceModalShow}
                    onClose={() => {
                        setDeviceModalShow(false);
                        setListKey((pre) => pre + 1);
                    }}
                />
            )}

            {chatRecordModalShow && (
                <ChatRecordModal
                    agentInfo={agentInfo}
                    visible={chatRecordModalShow}
                    onClose={() => setChatRecordModalShow(false)}
                />
            )}
        </div>
    );
};

export default injectIntl(AgentManage);
